module.exports = __webpack_public_path__ + "img/Feature.9a61529b.jpg";